import React, { useRef, useState } from "react";
import { useAuth } from "../../Store/AuthContext";
import NotifyMessageNoReload from "../../Utils/NotifyMessageNoReload";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import axios from "axios";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function CareersFormEnquery() {
  const { RendomTokenfetch } = useAuth();
  const subjectArr = [
    { name: "Sales Manager" },
    { name: "Real Estate Sales Executive" },
    { name: "Real Estate Accountant" },
    { name: "Pre-Sales Executive" },
    { name: "Office Assistant" },
    { name: "Other" },
  ];
  const [fullname, setfullname] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setemail] = useState("");
  const [subject, setSubject] = useState("");
  const userfileRef = useRef();
  const [loading, setLoading] = useState(false);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (fullname && mobileNumber && email) {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("name", fullname);
      fdata.append("number", mobileNumber);
      fdata.append("email", email);
      fdata.append("subject", subject);
      if (userfileRef.current.files[0]) {
        fdata.append("document", userfileRef.current.files[0]);
      }

      try {
        const response = await axios.post(
          `${WebsiteAPIurl}jobEnquiryAPI.php`,
          fdata,
          {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log(response.data);
        if (response.data.status === "1") {
          NotifyMessageNoReload(response.data.message, "success");
          setfullname("");
          setMobileNumber("");
          setemail("");
          setSubject("");
        } else {
          NotifyMessageNoReload(response.data.message, "danger");
        }
      } catch (error) {
        NotifyMessageNoReload(
          "Failed to send message. Please try again.",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    } else {
      NotifyMessageNoReload(
        "All fields are required. Please try again.",
        "danger"
      );
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  return (
    <>
      <form className="contact-form form was-validated" onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6 form-group">
            <input
              type="text"
              id="name"
              className="form-control"
              name="name"
              value={fullname}
              onChange={(e) => setfullname(e.target.value)}
              placeholder="Name*"
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              placeholder="Email Address"
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <input
              type="text"
              className="form-control"
              id="number"
              name="number"
              onChange={handleMobileChange}
              onKeyPress={handleKeyPress}
              value={mobileNumber}
              maxLength={10}
              inputMode="numeric"
              placeholder="Contact number*"
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <select
              className="form-select"
              name="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            >
              <option value="">Select</option>
              {subjectArr.map((sub, index) => (
                <option value={sub.name} key={index}>
                  {sub.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-12 form-group">
            <input
              type="file"
              id="myFile"
              name="userfile"
              accept=".doc, .docx, .pdf, .png, .jpg, .jpeg"
              required
              className="form-control"
              ref={userfileRef}
            />
          </div>

          <div className="col-12 text-center">
            <button
              type="submit"
              name="submit"
              className="modal-button theme-btn"
            >
              Send Message
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
